import { Component, OnInit } from '@angular/core';
import { TFMService } from 'app/mock-api/tfm.service';
import { Title, Meta } from '@angular/platform-browser';
import { TeamType01Component } from './team-type01/team-type01.component';
import { TeamType02Component } from './team-type02/team-type02.component';
import { TeamType03Component } from "./team-type03/team-type03.component";

@Component({
  selector: 'app-team',
  standalone: true,
  imports: [TeamType01Component, TeamType02Component, TeamType03Component],
  templateUrl: './team.component.html',
  styleUrl: './team.component.scss'
})
export class TeamComponent implements OnInit {

  public view: any = {
    title: 'Become a Member',
  }

  constructor(private _tfmService: TFMService, private title: Title, private metaService: Meta){}

  ngOnInit(): void {

    this._tfmService.getSite().then(res => {
      this.view.site = res;
      console.log('Site: ', this.view.site);

      if (this.view.site) {
        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);
      }

    });
      
  }

}
